import React, {useState} from 'react';
import {Col, Input, Label, Row} from 'reactstrap';
import {TrashIcon} from './TrashIcon';
import {EditIcon} from './EditIcon';
import {AddIcon} from './AddIcon';
import {setIsIMEIEditMode, setIsIMEIAddMode, setNewIMEINumber, setIsImeiChangeSuccsess} from '../PortalsBlock/portalSlice';
import {useDispatch, useSelector} from 'react-redux';
import {AddOrRemoveImeiAction} from '../PortalsBlock/portalSlice';
import FailurePopUp from './FailurePopUp';
import PopUp from '../../Shared/Popup/PopUp';
import AreYouSurePopUp from './AreYouSurePopUp';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import {useEffect} from 'react';

function AddOrRemoveImei(props) {
  const dispatch = useDispatch();
  const portalState = useSelector((state) => state.portalsBlock);
  const [showPopUpFail, setShowPopUpFail] = useState(false);
  const [showPopUpAreYouSure, setShowPopUpAreYouSure] = useState(false);
  const [selectedImei, setSelectedImei] = useState();
  const [selectedAction, setSelectedAction] = useState();
  const [result, setResult] = useState();
  useEffect(() => {
    if (!portalState.isIMEIEditMode) {
      dispatch(setIsIMEIAddMode(false));
    }
  }, [portalState.isIMEIEditMode, portalState.isIMEIAddMode]);

  const GetImeiDisplayText = (ban) => {
    const banRepairInfo = portalState.IMEINumbersRepairInfo;
    if(!banRepairInfo || !Array.isArray(banRepairInfo)){
      return ban;
    }

    const repairInfo = banRepairInfo.find(b => b.imei === ban);

    if(!repairInfo){
      return ban;
    }

    const text = repairInfo.hasRepairService ?
                `${ban} - אמש"ת: כן` : `${ban} - אמש"ת: לא`;

    return text;
  }

  const ImeiAction = async (IMEI, action, isSecondRound) => {
    dispatch(showAppLoader());
    const result = await dispatch(
      AddOrRemoveImeiAction({
        selectedNumber: props.props.isAllowed.phoneNumber,
        selectedImei: IMEI,
        action: action,
        isSecondRound: isSecondRound,
      }),
    );
    setResult(result.payload);
    if (!isSecondRound) {
      if (result.payload.isCheckSuccess) {
        setSelectedImei(IMEI);
        setSelectedAction(action);
        setShowPopUpAreYouSure(true);
      } else {
        setShowPopUpFail(true);
      }
    } else {
      if (!action) {
        if (!result.payload.isRemoveSuccess) {
          setShowPopUpFail(true);
        }
      }
    }

    if (result.payload.isAddSuccess || result.payload.isRemoveSuccess) {
      dispatch(setIsImeiChangeSuccsess({success: true, isAdd: result.payload.isAddSuccess, isRemove: result.payload.isRemoveSuccess}));
      let businessDetails = {_subscriber: props.props.isAllowed.phoneNumber ,'מספר IMEI': IMEI}
      props.props.reportDWH('IMEI_SUCCESS', {param3: IMEI, param4: action, businessDetails: businessDetails}, props);
    } else {
      if (result.payload.responseDescription !== 'ConnectedToInsurance' && result.payload.responseDescription !== 'CheckSuccess') {
        props.props.reportDWH('IMEI_ERROR', {param3: IMEI, param4: action}, props);
      }
    }
    dispatch(setIsIMEIAddMode(false));
    dispatch(setIsIMEIEditMode(false));
    dispatch(hideAppLoader());
  };

  return (
    <>
      <Row className='d-flex justify-content-between align-items-center  m-0'>
        <Label for='imeiNumberList'>מספר IMEI</Label>
        {!portalState.isIMEIEditMode && (
          <span
            style={{marginLeft: '11px', cursor: 'pointer'}}
            onClick={() => {
              dispatch(setIsIMEIEditMode(true));
              props.props.reportDWH('IMEI_EDIT_CLICK', '', props);
            }}>
            {portalState?.IMEIList?.length == 0 || !portalState?.IMEIList ? (
              <Label
                className='add-number d-flex align-items-center justify-content-start mt-2 mb-2'
                style={{cursor: 'pointer'}}
                onClick={() => dispatch(setIsIMEIAddMode(true))}>
                <AddIcon />
                <Label style={{cursor: 'pointer'}} className='m-0'>
                  הוסף מספר
                </Label>
              </Label>
            ) : (
              <EditIcon />
            )}
          </span>
        )}
      </Row>
      {portalState.IMEIList?.map((ban) => {
        return (
          <>
            <div className='position-relative d-flex align-items-center mb-2'>
              <Input style={{backgroundColor: portalState.isIMEIEditMode && 'white'}} disabled={true} defaultValue={GetImeiDisplayText(ban)} />
              {portalState.isIMEIEditMode && (
                <div
                  className='position-absolute text-end'
                  onClick={() => {
                    props.props.reportDWH('IMEI_DELETE_CLICK', {param3: ban}, props);
                    ImeiAction(ban, false, false);
                  }}
                  style={{left: '11px', cursor: 'pointer'}}>
                  <TrashIcon />
                </div>
              )}
            </div>
          </>
        );
      })}
      <div className='mt-2'>
        {portalState.isIMEIAddMode && (
          <Input
            maxLength={15}
            type='text'
            disabled={false}
            onChange={(e) => {
              dispatch(setNewIMEINumber(e.target.value));
            }}
          />
        )}
      </div>
      {portalState?.isIMEIEditMode && portalState?.IMEIList?.length < 3 && !portalState.isIMEIAddMode && (
        <div
          className='add-number d-flex justify-content-start mt-2 mb-2'
          style={{cursor: 'pointer'}}
          onClick={() => {
            dispatch(setIsIMEIAddMode(true));
            props.props.reportDWH('IMEI_ADD_CLICK', '', props);
          }}>
          <AddIcon />
          <span className='mr-2'>הוסף מספר</span>
        </div>
      )}
      {portalState.isIMEIEditMode && (
        <div className='edit-mode-buttons mt-3'>
          <Col xs='6' className={``}>
            <BtnWhite
              isBusiness
              text={`ביטול`}
              onclick={() => {
                dispatch(setIsIMEIAddMode(false));
                dispatch(setIsIMEIEditMode(false));
              }}
            />
          </Col>
          <Col xs='6' className={``}>
            <BtnSubmit
              type={'button'}
              isBusiness
              disabled={
                portalState.isIMEIAddMode &&
                portalState.newIMEINumber.toString().length > 14 &&
                portalState.newIMEINumber.toString() != null
                  ? false
                  : true
              }
              text={`שמירה`}
              onclick={(e) => {
                props.props.reportDWH('IMEI_SAVE_CLICK', {param3: portalState.newIMEINumber}, props);
                ImeiAction(portalState.newIMEINumber, true, false);
              }}
            />
          </Col>
        </div>
      )}

      <PopUp showPopUp={showPopUpFail} onClose={() => setShowPopUpFail(false)}>
        <FailurePopUp
          setIsShowPopup={setShowPopUpFail}
          isNewImaiValidationFail={result?.responseDescription === 'NewImeiNotValid' ? true : false}></FailurePopUp>
      </PopUp>
      <PopUp showPopUp={showPopUpAreYouSure} onClose={() => setShowPopUpAreYouSure(false)}>
        <AreYouSurePopUp
          res={result}
          setIsShowPopup={setShowPopUpAreYouSure}
          isIMEIEditMode={portalState.isIMEIEditMode}
          selectedImei={selectedImei}
          selectedAction={selectedAction}
          ImeiAction={ImeiAction}></AreYouSurePopUp>
      </PopUp>
    </>
  );
}

export default AddOrRemoveImei;
